/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/require-tagless-components */
import Component from '@ember/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { classNames } from '@ember-decorators/component';

// Text fields placeholders can be inserted into: the rubric editor's
// criteria wording only, not the rubric or element names and description.
const INSERTABLE = 'textarea.rubric-edit__criteria-textarea';

/**
 * A cheat sheet of the placeholders rubric wording can use. Clicking one
 * inserts it at the cursor in the text field that was last focused on the
 * page, as if it had been typed.
 */
@classNames('rubric-placeholder-legend')
export default class RubricPlaceholderLegend extends Component {
  PLACEHOLDERS = Object.freeze([
    { key: 'FIRSTNAME', description: "Student's first name" },
    { key: 'HE/SHE/THEY', description: 'he, she or they' },
    { key: 'HIM/HER/THEM', description: 'him, her or them' },
    { key: 'HIS/HER/THEIR', description: 'his, her or their' },
  ]);

  // The text field placeholders go into, and whether it's still focused
  _target = null;

  @tracked hasTarget = false;

  didInsertElement() {
    super.didInsertElement(...arguments);
    this._onFocusIn = (e) => {
      let el = e.target;
      if (el && el.matches && el.matches(INSERTABLE)) {
        this._target = el;
        this.hasTarget = true;
      }
    };
    document.addEventListener('focusin', this._onFocusIn);
  }

  willDestroyElement() {
    super.willDestroyElement(...arguments);
    document.removeEventListener('focusin', this._onFocusIn);
    this._target = null;
  }

  // Clicking moves focus to the button, but a text field keeps its caret
  // position after losing focus, so insert there and refocus it.
  @action
  insert(key) {
    let el = this._target;
    if (!el || !el.isConnected) {
      this.hasTarget = false;
      return;
    }
    let start = el.selectionStart != null ? el.selectionStart : el.value.length;
    let end = el.selectionEnd != null ? el.selectionEnd : start;
    el.focus();
    el.setRangeText(key, start, end, 'end');
    // Fire the field's own input handling so the record updates
    el.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
